module.exports = __webpack_public_path__ + "img/right.cc14df9f.svg";